import React from "react";

export default {
  "spotify-chat": {
    title: "Spotify Chat App",
    platformComponents: ["React", "Google Firebase"],
    description: (
      <p>
        I was annoyed when Spotify removed the direct messaging feature from
        their app so I decided to design and build a replacement. I built out
        most of the app because I wanted to try out Google’s Firebase and Cloud
        Functions. I ended up not finishing it because I started helping a
        friend with another Spotify app with similar functionality.
      </p>
    ),
    media: [
      {
        title: "Sending a Song",
        type: "video",
        path: "spotify-chat/send-song.mp4",
        description:
          "The most important function of the app is sending the song you are listening to to a friend. Users can also send text comments to each other."
      },
      {
        title: "Starting a New Thread",
        type: "video",
        path: "spotify-chat/new-thread.mp4",
        description:
          "Users can start a new thread with one or more friends by finding their spotify username and (assuming their friend(s) had the app) sending a song or message."
      }
    ]
  },
  "learn-a-bit": {
    title: "Learn a Bit",
    platformComponents: ["React", "GitHub Pages"],
    repoURL: "https://github.com/btbright/learn-a-bit",
    liveSiteURL: "https://btbright.github.io/learn-a-bit/",
    description: (
      <p>
        A simple quiz app to build an intuitive understanding of bit
        manipulation and operators.
      </p>
    ),
    media: [
      {
        title: "Example Usage",
        type: "video",
        path: "learn-a-bit/example.mp4",
        description:
          "There are four prompt types: provide the correct answer to a bitwise operation in binary, provide the correct operator to make the statement true, convert from base 10 to base 2, and convert from base 2 to base 10."
      }
    ]
  },
  "group-travel": {
    title: "Group Travel App",
    platformComponents: ["React", "NodeJS", "Redis", "Neo4j"],
    description: (
      <p>
        I went on a trip to Europe with 7 friends in the summer of 2017 and I
        built this app to help us organize it before we left. It’s basically a
        reddit clone with an itinerary. It was a quick project but ended up
        being pretty useful.
      </p>
    ),
    media: [
      {
        title: "Itinerary",
        type: "image",
        path: "group-travel/itinerary.jpg",
        description:
          'Here is the itinerary with some example data. OBIE was our silly name for the app: "Old Boys In Europe"'
      },
      {
        title: "Itinerary",
        type: "image",
        path: "group-travel/discussion.jpg",
        description:
          "An example discussion thread. Simple threaded discussion ala Reddit."
      }
    ]
  },
  "code-g": {
    title: "Code-G Tool",
    platformComponents: ["React", "GitHub Pages"],
    repoURL: "https://github.com/btbright/code-g",
    liveSiteURL: "https://btbright.github.io/code-g/",
    description: (
      <p>
        I built this tool with a friend who worked for a non-profit that does
        tax preparation for low-income families. Using the taxpayer’s financial
        information, it determines if the taxpayer is eligible for an exemption
        from the Affordable Care Act’s health insurance coverage requirement and
        provides details as to why or why they are not eligible. It has been
        used by thousands of taxpayers.
      </p>
    ),
    media: [
      {
        title: "Determining Eligibility",
        type: "video",
        path: "code-g/walkthrough.mp4",
        description: "An example of how the app is used (with fake data)"
      }
    ]
  },
  mecha: {
    title: "mecha",
    platformComponents: [
      "React",
      "styled-components",
      "Google Cloud Firestore"
    ],
    liveSiteURL: "https://mecha.video",
    description: (
      <p>
        A curated collection of excellent software conference videos. I built
        this with{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://twitter.com/scotato"
        >
          @scotato
        </a>{" "}
        because we both have learned so much from software conference talks but
        finding the good ones can be cumbersome - a work in progress.
      </p>
    ),
    media: [
      {
        title: "Video List",
        type: "image",
        path: "mecha/list.jpg",
        description: "The landing page - a collection of videos"
      },
      {
        title: "Video Page",
        type: "image",
        path: "mecha/video.jpg",
        description:
          'An individual video. Note the handy "Skip Intro" button. Also, the rocket ship on the right toggles between normal speed and a faster playback rate, set per-video by us.'
      }
    ]
  },
  aggbuzz: {
    title: "aggbuzz",
    platformComponents: ["React", "NodeJS", "Redis", "Neo4j"],
    liveSiteURL: "https://aggbuzz.com",
    description: (
      <p>
        A social platform to make video commenting / reactions fun. I built this
        with my friend{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://twitter.com/scotato"
        >
          @scotato
        </a>
        . The UX and tech of the platform were successful but we struggled to
        find a market so we shifted our energy to building a platform for
        software conference talks called mecha.
      </p>
    ),
    media: [
      {
        title: "Adding a Comment",
        type: "video",
        path: "aggbuzz/add-comment.mp4",
        description:
          'An example of adding a comment. Emotes are automatically detected and added for common emotional acronyms like "omg" or "lol".'
      },
      {
        title: "Adding an Emote",
        type: "video",
        path: "aggbuzz/emote.mp4",
        description:
          "An example of explicitly adding an emote from the small menu"
      },
      {
        title: "Liking a Comment",
        type: "video",
        path: "aggbuzz/like-comment.mp4",
        description:
          "Comments can be starred, which gives the commenter delicious internet points"
      },
      {
        title: "Landing Page Signup Process",
        type: "video",
        path: "aggbuzz/signup-bee.mp4",
        description: "Our landing page signup experience was pretty cute"
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/constants/projects.js